import makeLookupModal from "../../UI/LookupModal/LookupModal";
import HighSchoolGraduationTypeLookup from "./HighSchoolGraduationTypeLookup";
const HighSchoolGraduationTypeLookupModal = makeLookupModal(HighSchoolGraduationTypeLookup, {
    pluralEntityName: "High School Graduation Types",
});
export default HighSchoolGraduationTypeLookupModal;
